(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function parseConfig(root) {
    var script = root.querySelector('[data-cl-native-config]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('[native-lens-configurator] Invalid configuration', error);
      return null;
    }
  }

  function checkedValue(root, name) {
    var input = root.querySelector('input[name="' + name + '"]:checked');
    return input ? input.value : '';
  }

  function checkedInput(root, name) {
    return root.querySelector('input[name="' + name + '"]:checked');
  }

  function setGroup(root, name, visible) {
    var group = root.querySelector('[data-cl-native-group="' + name + '"]');
    if (!group) return null;
    var wasHidden = group.hidden;
    group.hidden = !visible;
    group.disabled = !visible;
    return visible && wasHidden ? group : null;
  }

  function scrollToRevealedGroup(root, group) {
    if (!group) return;
    var modal = root.closest('[data-cl-lens-modal]');
    var panel = modal && modal.querySelector('.cl-lens-modal__panel');
    if (!panel) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var groupRect = group.getBoundingClientRect();
        var panelRect = panel.getBoundingClientRect();
        var targetTop = panel.scrollTop + groupRect.top - panelRect.top - 24;
        panel.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
      });
    });
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }

    var value = Number(cents || 0) / 100;
    var amount = value.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    var amountNoDecimals = Math.round(value).toLocaleString('en-IN');
    var template = format || '{{amount}}';

    return template
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function readFrameVariants(actions) {
    var script = actions && actions.querySelector('[data-cl-lens-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent) || [];
    } catch (error) {
      return [];
    }
  }

  function frameVariant(form, actions, variants) {
    var id = form && form.elements.id ? form.elements.id.value : actions.getAttribute('data-cl-lens-current-variant-id');
    for (var i = 0; i < variants.length; i += 1) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return variants[0] || null;
  }

  function prescriptionFrame(root, config, selected) {
    var lensType = checkedValue(root, 'cl_lens_type');
    var lens = checkedValue(root, 'cl_lens');
    if (!config.isSunglasses || (lensType !== 'single' && lensType !== 'progressive') ||
        (lens !== 'tinted' && lens !== 'photochromatic')) return selected;

    var color = checkedInput(root, lens === 'tinted' ? 'cl_tint_color' : 'cl_photo_color');
    if (!color || !color.value || !color.dataset.variantId) throw new Error(config.frameErrors.color);

    var replacement = selected && config.prescriptionFrames && config.prescriptionFrames[String(selected.id)];
    if (replacement === null) return selected;
    if (!replacement || !replacement.id) throw new Error(config.frameErrors.mapping);
    if (!replacement.available) throw new Error(config.frameErrors.unavailable);
    return replacement;
  }

  function addOnSelections(root, config, frame) {
    var items = frame && frame.components ? frame.components.slice() : [];
    var lensType = checkedValue(root, 'cl_lens_type');
    var coating = checkedValue(root, 'cl_coating');
    var thickness = checkedValue(root, 'cl_thickness');
    var lens = checkedValue(root, 'cl_lens');

    if (lensType === 'zero' && coating === 'kodak' && config.coating && config.coating[coating]) {
      items.push(config.coating[coating]);
    }

    if (lensType !== 'zero' && config.lensType[lensType]) {
      items.push(config.lensType[lensType]);
    }

    if (lensType !== 'zero' && thickness !== 'standard' && config.thickness[thickness]) {
      items.push(config.thickness[thickness]);
    }

    if (lensType !== 'zero' && lens === 'tinted') {
      var tint = checkedInput(root, 'cl_tint_color');
      if (tint) items.push({ id: tint.dataset.variantId, price: Number(tint.dataset.price || 0), label: 'Tinted — ' + tint.value });
    }

    if (lensType !== 'zero' && lens === 'photochromatic') {
      var photo = checkedInput(root, 'cl_photo_color');
      if (photo) items.push({ id: photo.dataset.variantId, price: Number(photo.dataset.price || 0), label: 'Photochromatic X — ' + photo.value });
    }

    return items.filter(function (item) { return item && item.id; });
  }

  function syncSelectedColor(root, groupName, inputName) {
    var group = root.querySelector('[data-cl-native-group="' + groupName + '"]');
    var selected = checkedInput(root, inputName);
    var target = group && group.querySelector('[data-cl-native-selected-color]');
    if (target) target.textContent = selected ? selected.value : '';
  }

  function syncConditions(root) {
    var lensType = checkedValue(root, 'cl_lens_type');
    var lens = checkedValue(root, 'cl_lens');
    var prescription = checkedValue(root, 'cl_prescription');
    var powered = lensType !== 'zero';

    var revealed = null;
    var candidate = setGroup(root, 'coating', lensType === 'zero');
    if (!revealed && candidate) revealed = candidate;
    candidate = setGroup(root, 'vision', lensType === 'single');
    if (!revealed && candidate) revealed = candidate;
    candidate = setGroup(root, 'prescription', powered);
    if (!revealed && candidate) revealed = candidate;
    candidate = setGroup(root, 'upload', powered && prescription === 'Upload now');
    if (!revealed && candidate) revealed = candidate;
    candidate = setGroup(root, 'thickness', powered);
    if (!revealed && candidate) revealed = candidate;
    candidate = setGroup(root, 'lens', powered);
    if (!revealed && candidate) revealed = candidate;
    candidate = setGroup(root, 'tint-color', powered && lens === 'tinted');
    if (!revealed && candidate) revealed = candidate;
    candidate = setGroup(root, 'photo-color', powered && lens === 'photochromatic');
    if (!revealed && candidate) revealed = candidate;

    var file = root.querySelector('input[name="cl_prescription_file"]');
    if (file) file.required = powered && prescription === 'Upload now';

    syncSelectedColor(root, 'tint-color', 'cl_tint_color');
    syncSelectedColor(root, 'photo-color', 'cl_photo_color');
    return revealed;
  }

  function ensureAtcPrice(form) {
    var button = form.querySelector('button[type="submit"]');
    if (!button) return null;
    button.classList.add('cl-lens-modal-atc-btn');
    var price = button.querySelector('[data-cl-native-atc-price]');
    if (!price) {
      price = document.createElement('span');
      price.setAttribute('data-cl-native-atc-price', '');
      button.appendChild(price);
    }
    return price;
  }

  function appendProperty(formData, index, name, value) {
    if (value === '' || value == null) return;
    formData.append('items[' + index + '][properties][' + name + ']', value);
  }

  function configurationProperties(root) {
    var lensTypeInput = checkedInput(root, 'cl_lens_type');
    var lensType = lensTypeInput ? lensTypeInput.dataset.label : '';
    var powered = lensTypeInput && lensTypeInput.value !== 'zero';
    var properties = { 'Lens Type': lensType };

    if (!powered) {
      var coating = checkedInput(root, 'cl_coating');
      properties.Coating = coating ? coating.dataset.label : '';
      return properties;
    }

    if (lensTypeInput.value === 'single') properties.Vision = checkedValue(root, 'cl_vision');
    properties.Prescription = checkedValue(root, 'cl_prescription');

    var thickness = checkedInput(root, 'cl_thickness');
    var lens = checkedInput(root, 'cl_lens');
    properties.Thickness = thickness ? thickness.dataset.label : '';
    properties.Lens = lens ? lens.dataset.label : '';

    if (lens && lens.value === 'tinted') properties['Lens Color'] = checkedValue(root, 'cl_tint_color');
    if (lens && lens.value === 'photochromatic') properties['Lens Color'] = checkedValue(root, 'cl_photo_color');

    return properties;
  }

  function buildPayload(root, form, frame, addOns, sections) {
    var payload = new FormData();
    var configKey = 'cl-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    var properties = configurationProperties(root);

    payload.append('items[0][id]', String(frame.id));
    payload.append('items[0][quantity]', '1');
    Object.keys(properties).forEach(function (name) {
      appendProperty(payload, 0, name, properties[name]);
    });
    appendProperty(payload, 0, '_cl_lens_configuration', configKey);

    var file = root.querySelector('input[name="cl_prescription_file"]');
    if (file && file.files && file.files[0] && properties.Prescription === 'Upload now') {
      payload.append('items[0][properties][Prescription file]', file.files[0], file.files[0].name);
    }

    addOns.forEach(function (item, itemIndex) {
      var index = itemIndex + 1;
      payload.append('items[' + index + '][id]', String(item.id));
      payload.append('items[' + index + '][quantity]', '1');
      appendProperty(payload, index, '_tpo_add_on_key', configKey);
      appendProperty(payload, index, '_cl_parent_variant', String(frame.id));
      appendProperty(payload, index, '_cl_selection', item.label);
    });

    payload.append('sections', sections.join(','));
    payload.append('sections_url', ROOT + 'variants/' + frame.id);
    return payload;
  }

  function showError(root, message) {
    var target = root.querySelector('[data-cl-native-error]');
    if (!target) return;
    target.textContent = message || '';
    target.hidden = !message;
  }

  function wire(root) {
    if (root.dataset.clNativeWired === '1') return;
    root.dataset.clNativeWired = '1';

    var config = parseConfig(root);
    var form = root.closest('form.shopify-product-form');
    var modal = root.closest('[data-cl-lens-modal]');
    var sectionId = modal ? modal.id.replace('cl-lens-modal-', '') : '';
    var actions = document.querySelector('[data-cl-lens-actions][data-cl-lens-section-id="' + sectionId + '"]');
    if (!config || !form || !actions) return;

    var variants = readFrameVariants(actions);
    var atcPrice = ensureAtcPrice(form);

    function renderPrice() {
      var frame;
      try {
        frame = prescriptionFrame(root, config, frameVariant(form, actions, variants));
      } catch (error) {
        if (atcPrice) atcPrice.textContent = '';
        showError(root, error.message);
        return;
      }
      showError(root, '');
      var total = frame ? Number(frame.price || 0) : 0;
      addOnSelections(root, config, frame).forEach(function (item) { total += Number(item.price || 0); });
      if (atcPrice) atcPrice.textContent = formatMoney(total, config.moneyFormat);
    }

    root.addEventListener('change', function (event) {
      var revealedGroup = syncConditions(root);
      showError(root, '');
      renderPrice();
      scrollToRevealedGroup(root, revealedGroup);

      if (event.target && event.target.type === 'file') {
        var fileName = root.querySelector('[data-cl-native-file-name]');
        if (fileName) fileName.textContent = event.target.files && event.target.files[0] ? event.target.files[0].name : 'No file selected';
      }
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (root.getAttribute('aria-busy') === 'true') return;

      syncConditions(root);
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var frame;
      try {
        frame = prescriptionFrame(root, config, frameVariant(form, actions, variants));
      } catch (error) {
        showError(root, error.message);
        return;
      }
      if (!frame || frame.available === false) {
        showError(root, 'This frame selection is not currently available.');
        return;
      }

      var button = form.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }
      root.setAttribute('aria-busy', 'true');
      showError(root, '');
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      }));

      try {
        var payload = buildPayload(root, form, frame, addOnSelections(root, config, frame), sections);
        var response = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          body: payload,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        var responseJson = await response.json();

        if (!response.ok) throw new Error(responseJson.description || responseJson.message || 'Unable to add this configuration to the cart.');

        if (window.themeVariables && (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart')) {
          window.location.href = ROOT + 'cart';
          return;
        }

        var cart = await (await fetch(ROOT + 'cart.js')).json();
        cart.sections = responseJson.sections;
        form.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: { items: responseJson.items || [responseJson], cart: cart }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: cart }
        }));

        /* Shopify can return a stale empty drawer section when the cart was
           empty before a multi-item add. Refresh it from the current cart,
           then open it only after the fresh section has been rendered. */
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.show === 'function') {
          cartDrawer.addEventListener('cart-drawer:refreshed', function () {
            cartDrawer.show();
          }, { once: true });
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        var closeButton = modal && modal.querySelector('.cl-lens-modal__close');
        if (closeButton) closeButton.click();
      } catch (error) {
        showError(root, error.message || 'Unable to add this configuration to the cart.');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } finally {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
        root.removeAttribute('aria-busy');
        document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      }
    }, true);

    var rerender = actions.closest('product-rerender');
    if (rerender) rerender.addEventListener('variant:change', renderPrice);

    syncConditions(root);
    renderPrice();
  }

  function init() {
    document.querySelectorAll('[data-cl-native-lens-configurator]').forEach(wire);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
